module.exports = __webpack_public_path__ + "static/media/cal.34bb8095.svg";